import * as THREE from 'three/webgpu';


/**
 * 方向箭头轴向拖拽阶段。
 */
export enum PatternDirectionArrowAxisDragPhase {
    /** 拖拽开始。 */
    Start = 'start',
    /** 拖拽过程。 */
    Change = 'change',
    /** 拖拽结束。 */
    End = 'end',
}

/**
 * 方向箭头轴向拖拽配置。
 */
export interface PatternDirectionArrowAxisDragOptions {
    /** 是否启用轴向拖拽。 */
    enabled: boolean;
    /** 拖拽上下文标识，用于业务方区分不同箭头来源。 */
    contextKey?: string;
    /** 起始标量值，拖拽增量会基于该值派发。 */
    scalarValue?: number;
    /** 场景单位到业务标量单位的换算比例。 */
    sceneUnitToScalarScale?: number;
}

/**
 * 方向箭头轴向拖拽事件载荷。
 */
export interface PatternDirectionArrowAxisDragEvent {
    /** 拖拽阶段。 */
    phase: PatternDirectionArrowAxisDragPhase;
    /** 触发拖拽的箭头对象。 */
    arrow: THREE.Object3D;
    /** 拖拽上下文标识。 */
    contextKey: string;
    /** 拖拽开始时的业务标量值。 */
    startScalarValue: number;
    /** 当前业务标量值。 */
    scalarValue: number;
    /** 沿轴方向的场景单位增量。 */
    deltaScene: number;
    /** 沿轴方向的业务标量增量。 */
    deltaScalar: number;
    /** 拖拽轴原点。 */
    axisOriginWorld: THREE.Vector3;
    /** 拖拽轴方向。 */
    axisDirectionWorld: THREE.Vector3;
    /** 事件触发时的客户端 X 坐标。 */
    clientX: number;
    /** 事件触发时的客户端 Y 坐标。 */
    clientY: number;
}

